<template>
  <div>
    <flipbook class="flipbook" :pages="items"></flipbook>
  </div>
</template>

<script>
import Flipbook from "flipbook-vue/dist/vue2/flipbook";

export default {
  props: {
    items: {
      type: Array, // string[]
      required: true,
    },
  },
  components: { Flipbook },
};
</script>

<style>
.flipbook {
  width: 100%;
  height: 1080px;
}

@media screen and (max-width: 599.9px) {
  .flipbook {
    width: 90vw !important;
    height: 90vh !important;
  }
}
</style>
